import { Logout, Person } from "@mui/icons-material";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { useState } from "react";
import LogoutConfirmPopup from "../../popups/LogoutConfirmPopup";

const UserProfileMenu = ({open, handleClose, anchor, userName}) => {
    const [showPopup, setShowPopup] = useState(false);

    const onClickLogout = () => {
        setShowPopup(true);
        handleClose();  
    } 

    return (
        <>
            <LogoutConfirmPopup show={showPopup} setShow={setShowPopup} />
            <Menu
                anchorEl={anchor}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}>
                <MenuItem divider={true}>
                    <ListItemIcon>
                        <Person fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{userName}</ListItemText>
                </MenuItem>
                <MenuItem onClick={onClickLogout}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Logout</ListItemText>
                </MenuItem>
            </Menu>
        </>
    )
}

export default UserProfileMenu;